<template>
	<MenuPopup id="recaptcha-v2-popup-id" ref="recaptcha-v2-popup" :title="languageStore.getString('recaptchaV2Title')" @toggling-popup="resetCaptcha" :z-index="1001">
		<div id="recaptcha-v2" class="g-recaptcha"></div>
	</MenuPopup>
</template>

<script>
import { useCartStore } from "@/new-menu/stores";
import { useLanguageStore, useNotificationStore } from "@/shared/stores";
import MenuPopup from "@/new-menu/components/generic/MenuPopup.vue";

export default {
	setup() {
		const cartStore = useCartStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return { cartStore, languageStore, notificationStore };
	},
	data() {
		return {
			captchaResetFromWatch: false,
		};
	},
	props: {
		customFailNotification: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['showNotification'],
	name: "CaptchaPopup",
	components: { MenuPopup },
	methods: {
		resetCaptcha(status) {
			if (!status) {
				if (!this.captchaResetFromWatch) {
					if (!this.cartStore.currentRecaptchaTokenV2) {
						this.cartStore.resetCaptchaMode();
						
						if (!this.customFailNotification) {
							this.notificationStore.showNotification('captcha_failed');
						} else {
							this.$emit('showNotification');
						}
					}
				}
				this.captchaResetFromWatch = false;
				this.cartStore.showRecaptchaPopupV2 = false;
			}
		},
		showPopup(newVal) {
			this.$nextTick(() => {
				const popupRef = this.$refs['recaptcha-v2-popup'];
					if (popupRef && typeof popupRef.toggleStatus === 'function') {
						popupRef.toggleStatus(newVal);
					}
			});
		},
	},
	watch: {
		'cartStore.showRecaptchaPopupV2': {
			handler(newVal) {
				if (!newVal) this.captchaResetFromWatch = true;
				this.showPopup(newVal);
			},
			immediate: true,
		},
	}
}
</script>

<style lang="scss">
#recaptcha-v2-popup-id .popup-body {
	@include hideScrollbar();
}
</style>